// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICarrierDto
 */
export interface ICarrierDto {
    /**
     * 
     * @type {number}
     * @memberof ICarrierDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICarrierDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ICarrierDto
     */
    external_id?: string | null;
}

/**
 * Check if a given object implements the ICarrierDto interface.
 */
export function instanceOfICarrierDto(value: object): value is ICarrierDto {
    return true;
}

export function ICarrierDtoFromJSON(json: any): ICarrierDto {
    return ICarrierDtoFromJSONTyped(json, false);
}

export function ICarrierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICarrierDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'external_id': json['external_id'] == null ? undefined : json['external_id'],
    };
}

export function ICarrierDtoToJSON(json: any): ICarrierDto {
    return ICarrierDtoToJSONTyped(json, false);
}

export function ICarrierDtoToJSONTyped(value?: ICarrierDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'external_id': value['external_id'],
    };
}

